import useSWRImmutable from 'swr/immutable';
import PackageService from '@/services/TourServices/PackageService';

const usePackageInclusionsExclusions = () => useSWRImmutable(
    'package-inclusions-exclusions',
    PackageService.getInclusionsExclusions,
);

export default usePackageInclusionsExclusions;
